import React from "react";
import { Card, Form, Row, Col, Button, Badge } from 'react-bootstrap';
import sanitizeHtml from 'sanitize-html';


function AiNewsCard({ id, title, description, content, categoryName, onSelect, selected , hasBeenImported, date, onDiscard, flag, flag_reason, applied_policies, backgroundClass, flagLabel, imported_to, onOtherReason }) {
    let sanitizedHtml = null;
    if(content)
    {
        sanitizedHtml = sanitizeHtml(content);
    }
    const handleCheckboxChange = () => {
        onSelect(id, title); // Notificamos al padre cuando cambia el estado del checkbox
    };
    
    return (
         <Card className="mt-2 mb-2">
            {/* <Card.Body> */}
            <Card.Body className={backgroundClass}>
                <Row>
                    <Col md={2} >
                            <Form.Check 
                            type="checkbox" 
                            label="Seleccionar"
                            id={`customCheckbox_${id}`}  
                            checked={selected} 
                            onChange={handleCheckboxChange} 
                        />
                    </Col>
                    <Col md={10} className="text-end">
                <Button
                    type="button"
                    className="me-2 btn-info btn-sm"
                    style={{ padding: "2px 6px", fontSize: "0.75rem" }}
                    onClick={() => onDiscard(id, null)}
                >
                    <i className="bi bi-trash3-fill"></i> No me sirve
                </Button>
                <Button
                    type="button"
                    className="btn-info btn-sm"
                    style={{ padding: "2px 6px", fontSize: "0.75rem" }}
                    onClick={onOtherReason}
                >
                    <i className="bi bi-trash3-fill"></i> Otro motivo
                </Button>
            </Col>
                </Row>
              
                <Card.Title>{title}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">{description}</Card.Subtitle>
                <Card.Text dangerouslySetInnerHTML={{ __html: sanitizedHtml }} >                    
                </Card.Text>
                {flagLabel && (
                    <div className="mb-2">
                        <Badge bg="secondary">{flagLabel}</Badge>
                    </div>
                )}
                
                {flag_reason && (
                    <div className="text-muted" style={{ fontSize: '0.85em' }}>
                        <strong>Motivo:</strong> {flag_reason}
                    </div>
                )}

                {applied_policies && (
                <div className="text-muted mb-2" style={{ fontSize: '0.85em' }}>
                    <strong>Normas aplicadas:</strong> {applied_policies}
                </div>
                )}
            </Card.Body>
            <Card.Footer className="text-muted">
                {/* Sección de estado de importación y badges */}
                <Row className="mb-2">
                    <Col>
                        {hasBeenImported ? (
                            <b className="text-danger">Ya importada</b>
                        ) : imported_to && imported_to.length > 0 ? (
                            <b className="text-warning">Importada a otros sitios</b>
                        ) : (
                            <b className="text-success">Nunca importada</b>
                        )}
                        {imported_to && imported_to.length > 0 && (
                            <div className="mt-2">
                                {imported_to.map((item, index) => (
                                    <Badge key={index} bg="info" className="me-1" style={{ fontSize: '0.75em' }}>
                                        {item}
                                    </Badge>
                                ))}
                            </div>
                        )}
                    </Col>
                </Row>

                {/* Sección de ID y fecha */}
                <Row>
                    <Col md={4}>
                        <span><strong>ID:</strong> {id}</span>
                    </Col>
                    <Col md={8} className="text-end">
                        <span><strong>Fecha:</strong> {date}</span>
                    </Col>
                </Row>
            </Card.Footer>
        </Card>
    );
}

export default AiNewsCard;